import React, { useState, useEffect, useRef } from 'react';
import { Component } from "react";
import { Link } from "react-router-dom";
import { isAuth, signout, getCokie } from "../helpers/auth"
import { toast } from "react-toastify";
import axios from "axios";
// import authSvgwww from "../assests/www3.svg";
// import authSvgwwww from "../assests/www3.svg";
import { HashLink } from 'react-router-hash-link';

export default function AppNavbar() {
  // State to track if the navbar is expanded
  // const [Svgwwww, setSvgwwww] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [userr, setUserr] = useState('');
  const [name, setName] = useState('');

  // Create a reference attached to the main navigation element
  const navbarRef = useRef(null);

  const [imageSrc, setImageSrc] = useState(null);


  // Close the navbar when a click is detected outside of navbarRef
  useEffect(() => {
    var month = new Date().getMonth()
    import(`../assests/www${(month + 1)}.svg`)
      .then((image) => setImageSrc(image.default))
      .catch((err) => console.error("Failed to load image", err))    // Use a template literal to insert the variable into the path
    if (isAuth()) {
      getUser()
    }
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    }

    // Bind the event listener to the document
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleClickOutside);
    };
  }, []);

  const getUser = async () => {
    const token = getCokie("token");
    await axios.get(
      `${process.env.REACT_APP_API_URL}/users/user/${isAuth()._id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setUserr(res.data)
        setName(res.data.name.slice(0, 1).toUpperCase())
        console.log(res.data, "navigation")
      })
      .catch((err) => {
        // toast.error(`Error To Your Information ${err.response.statusText}`);
        if (err.response.status === 401) {
          signout(() => {
            window.location.href = "/login";
          });
        }
      })
    //console.log(res.data  );

  };


  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light text-uppercase" ref={navbarRef}>
      <div className="container-fluid">
        <div className="navbar-brand text-uppercase text-center p-0" to="/">
          {isAuth() ? <Link to="/private" className="shadow-none" >
            {hasError ?
              <div className="wrapperestperfil name">{name}</div>
              :
              <img className="wrapperestperfil" src={`${process.env.REACT_APP_URL}/collections/` + userr.foto}
                onError={() => setHasError(true)}
              />
            }
          </Link> :
            <Link to="/">
              <img className="p-1 m-auto wrapperestperfil" src={`${imageSrc}`} ></img>
            </Link>
          }
        </div>

        {/* Toggle button */}
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={isExpanded}
          aria-label="Toggle navigation"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible wrapper controlled by the React state */}
        <div className={`collapse navbar-collapse ${isExpanded ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <HashLink className="nav-link" to="/#section-one">
                Documentos
              </HashLink>
            </li>
            <li className="nav-item">
              <Link to="/cursos" className="nav-link">
                Cursos
              </Link>
            </li>
            {isAuth() ? (
              <>
                <li>
                  <Link to="/carpeta" className="nav-link">
                    PANEL
                  </Link>

                </li>
                <li className="nav-item">
                  <Link to="/" className="nav-link" onClick={() => setIsExpanded(false)}>
                    Inicio
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/Login"
                    onClick={() => {
                      signout(() => {
                        window.location.href = "/login";
                      });
                    }}
                    className="nav-link"
                  >
                    Cerrar
                  </Link>
                </li>
              </>
            ) :
              <li className="nav-item">
                <Link to="/login" className="nav-link">
                  Iniciar
                </Link>
              </li>
            }

          </ul>

        </div>
      </div>
    </nav>
  );
}
